// Configurable, indicative confidence tiers. These are NOT validated accuracy scores.
export const CONFIDENCE_CONFIG = {
  idwPower: 2,
  coverageLimitMi: 300,
  farThresholdMi: 40,
  tiers: [
    { maxMi: 0, level: 4, label: "Direct observation site", tone: "high" },
    { maxMi: 15, level: 3, label: "Close to a station", tone: "good" },
    { maxMi: 40, level: 2, label: "Moderate distance", tone: "moderate" },
    { maxMi: Infinity, level: 1, label: "Far from stations", tone: "low" },
  ],
};

export const getConfidence = (distanceMi, kind) => {
  if (kind === "station") return { ...CONFIDENCE_CONFIG.tiers[0], isFar: false };
  const tier = CONFIDENCE_CONFIG.tiers.slice(1).find((t) => distanceMi <= t.maxMi);
  return { ...tier, isFar: distanceMi > CONFIDENCE_CONFIG.farThresholdMi };
};
